import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { spacesApi } from '../../../api/spacesApi/spacesAPIclient'

export interface SpaceComment {
  id: string
  message: string
  email: string
  firstName?: string | null
  lastName?: string | null
  read: boolean
  nodeId?: string | null
  rootNodeId: string
  pageId?: string | null
  blockId?: string | null
  createdAt: string
  updatedAt: string
  deletedAt?: string | null
  whitelistedUserId?: string | null
  sellerId?: string | null
  page?: any
  node?: any
  block?: any
}

interface UseSpaceCommentsOptions {
  enabled?: boolean
}

/**
 * Hook to fetch comments for a specific space
 * @param spaceId - The ID of the space to fetch comments for
 * @param options - Additional options for the query
 * @returns Query result with comments data, loading state, and error
 */
export const useSpaceComments = (spaceId?: string, options: UseSpaceCommentsOptions = {}) => {
  const { enabled = true } = options

  const queryKey = useMemo(() => ['spaceComments', spaceId], [spaceId])

  return useQuery<SpaceComment[]>({
    queryKey,
    queryFn: async ({ signal }) => {
      if (!spaceId) return []

      const response = await spacesApi.get(`/comments/get_for_space/${spaceId}`, {
        signal,
      })

      return response.data
    },
    enabled: enabled && !!spaceId,
    staleTime: 1000 * 30, // 30 seconds
  })
}
